export default __webpack_public_path__ + "static/media/heartbeat.79fb2e74.mp3";